import React from 'react';
import { Lock, TrendingUp, Sparkles } from 'lucide-react';
import { useToast } from '../contexts/ToastContext';

interface UpgradePromptProps {
  moduleName?: string;
  compact?: boolean;
}

export function UpgradePrompt({ moduleName = 'Gestão Operacional', compact = false }: UpgradePromptProps) {
  const toast = useToast();

  const handleUpgradeClick = () => {
    // Em produção, isso redirecionaria para a página de upgrade ou abriria um modal
    toast.info('Fale com nosso time comercial', 'Entre em contato para fazer upgrade para o Plano Completo!');
  };

  if (compact) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 bg-gray-50 rounded-lg border border-gray-200 cursor-pointer hover:bg-gray-100 transition-colors"
           onClick={handleUpgradeClick}>
        <Lock className="h-4 w-4 text-gray-400" />
        <span className="text-sm text-gray-600">{moduleName}</span>
        <span className="ml-auto text-xs bg-coral-deep text-white px-2 py-0.5 rounded-full">
          Plano Completo
        </span>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 rounded-lg border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-white rounded-lg shadow-sm">
            <Lock className="h-5 w-5 text-gray-400" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900">{moduleName}</h3>
        </div>
        <span className="text-xs bg-coral-deep text-white px-3 py-1 rounded-full font-medium">
          Plano Completo
        </span>
      </div>
      
      <p className="text-sm text-gray-600 mb-4">
        Desbloqueie recursos avançados de gestão operacional para sua empresa.
      </p>
      
      <div className="space-y-2 mb-6">
        <div className="flex items-center gap-2 text-sm text-gray-700">
          <TrendingUp className="h-4 w-4 text-green-500" />
          <span>Controle completo de operações</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-700">
          <Sparkles className="h-4 w-4 text-yellow-500" />
          <span>Recursos avançados de automação</span>
        </div>
      </div>
      
      <button
        onClick={handleUpgradeClick}
        className="w-full bg-coral-deep text-white py-2 px-4 rounded-lg font-medium hover:brightness-90 transition-all transform hover:scale-[1.02] shadow-md"
      >
        Fazer Upgrade Agora
      </button>
    </div>
  );
}